import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BaseLearningSectionComponent } from '../../../../shared/learning-section/base-learning-section/base-learning-section.component';
import { LearningSectionFlowControlHelperService } from '../../../../_helpers/learning-section-flow-control-helper/learning-section-flow-control-helper.service';
import { ProgressReportTimelineSection } from '../../../../_models/timeline-models/section-models/progress-report-section.model';
import { SEMH_LABELS, SEMH_MIN, SEMH_MAX } from '../../../tutor-report-flows/tutor-report-leap-v2/models/leap-v2-semh';

/**
 * Timeline card for a LEAP v2 6-week Progress Report (sectionType 'progress-report'). One per report.
 * Renders read-only straight from the timeline payload (unlike the ILP card, which fetches, because a
 * learner has many progress reports) and links to that specific report.
 */
@Component({
  selector: 'leap-v2-progress-report-section',
  templateUrl: './leap-v2-progress-report-section.component.html',
  styleUrls: ['./leap-v2-progress-report-section.component.css'],
  standalone: false,
})
export class LeapV2ProgressReportSectionComponent extends BaseLearningSectionComponent {
  @Input() timelineSection: ProgressReportTimelineSection;

  readonly percentTicks = ['0%', '25%', '50%', '75%', '100%'];
  readonly semhLabels = SEMH_LABELS;
  readonly semhMin = SEMH_MIN;
  readonly semhMax = SEMH_MAX;

  constructor(
    protected readonly flowHelperService: LearningSectionFlowControlHelperService,
    public dialog: MatDialog,
    private router: Router
  ) {
    super(flowHelperService, dialog);
    this.sectionTitle = 'Progress Report';
  }

  /** Effective status id (1 Saved, 2 Submitted, 3 Approved, 4 Rejected); falls back to approved/draft. */
  private effectiveStatusId(): number {
    return this.timelineSection?.statusId ?? (this.timelineSection?.approved ? 3 : 1);
  }

  statusLabel(): string {
    switch (this.effectiveStatusId()) {
      case 1: return 'Saved';
      case 2: return 'Submitted';
      case 3: return 'Approved';
      case 4: return 'Rejected';
      default: return '';
    }
  }

  statusClass(): string {
    switch (this.effectiveStatusId()) {
      case 1: return 'pr-status--saved';
      case 2: return 'pr-status--submitted';
      case 3: return 'pr-status--approved';
      case 4: return 'pr-status--rejected';
      default: return '';
    }
  }

  openReport(): void {
    this.router.navigate(['/progress-report', this.timelineSection.placementId, this.timelineSection.studentId], {
      queryParams: { reportId: this.timelineSection.id }
    });
  }
}
